export * from './partners';
export { default } from './partners';
